const $$splitComponentImporter = () => import('/app/frontend/src/routes/_app/user/notifications/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_app/user/notifications/')({
  staticData: {
    breadCrumb: 'Notifications'
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});